import React from 'react'
import { Box } from '@material-ui/core'
import TaxItemForm from './TaxItemForm'
import { LanguageConsumer } from '../../context/LanguageContext'
import { ItemsListConsumer } from '../../context/ItemsListContext'
import InvoiceGetPublicLink from './InvoiceGetPublicLink'
import CancelRejectInvoiceForm from './CancelRejectInvoiceForm'
import DeclineCancelRejectConfirmation from './DeclineCancelRejectConfirmation'
import CurrencyForm from './CurrencyForm'
import CodeUsageForm from './CodeUsageForm'
import EGSCodeUsageForm from './EGSCodeUsageForm'
import InvoicePackageForm from './InvoicePackageForm'
import PackageItemCodesForm from './PackageItemCodesForm'
import CodesBulkImportForm from './CodesBulkImportForm'
import { ListingConsumer } from '../../context/ListingContext'
import DraftDeleteForm from './DraftDeleteForm'
import DraftSignForm from './DraftSignForm'
import TemplateSave from './TemplateSave'
import DashboardFilterForm from './DashboardFilterForm'
import LateSubmissionForm from './LateSubmissionForm'

const EntityAddForm = ({ entityName, onSubmit, currentData, cancelDialog, currentAction, updateParentEntity, netTotal, totalTaxableFees, calculatedFees, valueDifference, currency, codeUsageRequestID, codeUsageUniqueID, currentCodeLoading, currenciesKeys, updateSelectedRows }) => {
  const searchFiltersSwitcher = () => {
    switch (entityName) {
      case 'taxableItems':
        return <LanguageConsumer>
          {({ locale }) => (
            <ItemsListConsumer>
              {({ listingData }) => (
                <TaxItemForm currentData={currentData}
                             onSubmit={onSubmit}
                             totalTaxableFees={totalTaxableFees}
                             calculatedFees={calculatedFees}
                             valueDifference={valueDifference}
                             netTotal={netTotal}
                             locale={locale}
                             listingData={listingData}
                             currency={currency}
                             updateParentEntity={updateParentEntity}
                             currentAction={currentAction}
                             cancelDialog={cancelDialog}/>
              )}
            </ItemsListConsumer>
          )}
        </LanguageConsumer>
      case 'invoicesActions-get-public-link':
        return <InvoiceGetPublicLink currentData={currentData}/>
      case 'invoicesActions-cancel':
      case 'invoicesActions-reject':
        return <CancelRejectInvoiceForm onSubmit={onSubmit}
                                        currentAction={currentAction}
                                        cancelDialog={cancelDialog}/>
      case 'invoicesActions-decline-cancel':
      case 'invoicesActions-decline-reject':
        return <DeclineCancelRejectConfirmation/>
      case 'currency':
        return <LanguageConsumer>
          {({ locale }) => (
            <CurrencyForm currentData={currentData}
                          currenciesKeys={currenciesKeys}
                          onSubmit={onSubmit}
                          locale={locale}
                          updateParentEntity={updateParentEntity}
                          currentAction={currentAction}
                          cancelDialog={cancelDialog}/>
          )}
        </LanguageConsumer>
      case 'codeUsage':
        return <LanguageConsumer>
          {({ locale }) => (
            <CodeUsageForm currentData={currentData}
                           codeUsageRequestID={codeUsageRequestID}
                           onSubmit={onSubmit}
                           locale={locale}
                           currentCodeLoading={currentCodeLoading}
                           currentAction={currentAction}
                           updateParentEntity={updateParentEntity}
                           cancelDialog={cancelDialog}/>
          )}
        </LanguageConsumer>
      case 'EGSCodeUsage':
        return <LanguageConsumer>
          {({ locale }) => (
            <EGSCodeUsageForm currentData={currentData}
                              codeUsageUniqueID={codeUsageUniqueID}
                              onSubmit={onSubmit}
                              locale={locale}
                              currentAction={currentAction}
                              currentCodeLoading={currentCodeLoading}
                              updateParentEntity={updateParentEntity}
                              cancelDialog={cancelDialog}/>
          )}
        </LanguageConsumer>
      case 'codesBulkImport':
        return <CodesBulkImportForm onSubmit={onSubmit}
                                    currentAction={currentAction}
                                    updateParentEntity={updateParentEntity}
                                    cancelDialog={cancelDialog}/>
      case 'invoicePackages':
        return <LanguageConsumer>
          {({ locale }) => (
            <InvoicePackageForm currentData={currentData}
                                codeUsageUniqueID={codeUsageUniqueID}
                                onSubmit={onSubmit}
                                locale={locale}
                                currentAction={currentAction}
                                currentCodeLoading={currentCodeLoading}
                                updateParentEntity={updateParentEntity}
                                cancelDialog={cancelDialog}/>
          )}
        </LanguageConsumer>

      case 'dashboard':
        return <LanguageConsumer>
          {({ locale }) => (
            <DashboardFilterForm currentData={currentData}
                                 onSubmit={onSubmit}
                                 locale={locale}
                                 cancelDialog={cancelDialog}/>
          )}
        </LanguageConsumer>

      case 'packageItemCodes':
        return <LanguageConsumer>
          {({ locale }) => (
            <PackageItemCodesForm onSubmit={onSubmit}
                                  locale={locale}
                                  updateParentEntity={updateParentEntity}/>
          )}
        </LanguageConsumer>

      case 'drafts':
        switch (currentAction) {
          case 'delete':
          case 'bulk-delete':
            return <ListingConsumer>
              {({ deleteItemLoading }) => (
                <DraftDeleteForm currentData={currentData}
                                 onSubmit={onSubmit}
                                 isBulk={currentAction === 'bulk-delete'}
                                 updateSelectedRows={updateSelectedRows}
                                 loading={deleteItemLoading}
                                 cancelDialog={cancelDialog}/>
              )}
            </ListingConsumer>

          case 'sign':
          case 'bulk-sign':
            return <DraftSignForm currentData={currentData}
                                  updateParentEntity={updateParentEntity}
                                  updateSelectedRows={updateSelectedRows}
                                  isBulk={currentAction === 'bulk-sign'}
                                  cancelDialog={cancelDialog}/>
          default:
            return ''
        }

      case 'templates':
        switch (currentAction) {
          case 'delete':
          case 'bulk-delete':
            return <ListingConsumer>
              {({ deleteItemLoading }) => (
                <DraftDeleteForm currentData={currentData}
                                 onSubmit={onSubmit}
                                 isTemplate
                                 isBulk={currentAction === 'bulk-delete'}
                                 updateSelectedRows={updateSelectedRows}
                                 loading={deleteItemLoading}
                                 cancelDialog={cancelDialog}/>
              )}
            </ListingConsumer>

          case 'edit':
            return <TemplateSave currentData={currentData}
                                 onSubmit={onSubmit}
                                 list
                                 cancelDialog={cancelDialog}/>
          default:
            return ''
        }

      case 'lateSubmission':
        return <LanguageConsumer>
            {({ locale }) => (
              <LateSubmissionForm cancelDialog={cancelDialog} onSubmit={onSubmit} locale={locale}/>
            )}
          </LanguageConsumer>

      default:
        return ''
    }
  }
  return (
    <Box p={3}>
      {!!entityName && searchFiltersSwitcher()}
    </Box>
  )
}

export default EntityAddForm
